import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input } from '@angular/core';
import { PictureComponent } from '../picture/picture.component';

@Component({
    selector: 'finder-image-drawer',
    templateUrl: './image-drawer.component.html',
    styleUrls: ['./image-drawer.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        PictureComponent
    ]
})
export class ImageDrawerComponent {
    @Input() data: any[];

    constructor(
        private elementRef: ElementRef,
    ) {}

    /* istanbul ignore next */
    getElementRef() {
        return this.elementRef.nativeElement;
    }
}
